module.exports = __webpack_public_path__ + "static/media/lightndark.4f912466.eot";